import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from './SettingItem.module.scss';

const cx = classnames.bind(styles);

type SettingItemProps = {
  label: string;
  value: ReactNode;
  className?: string;
};

export const SettingItem: FC<SettingItemProps> = ({
  label,
  value,
  className,
}) => {
  return (
    <div className={cx('itemWrapper', className)}>
      <div className={cx('itemContent')}>
        <div className={cx('itemLabel')}>
          <span>{label}</span>
        </div>
        <div className={cx('itemValue')}>
          <div className={cx('itemValueContent')}>{value}</div>
        </div>
      </div>
    </div>
  );
};
